module.exports = __webpack_public_path__ + "static/media/logo-dashboard.eb6747ed.svg";